<script setup>
import CsaHeader from "@/components/CsaHeader.vue";
import CSaFooter from "@/components/CSaFooter.vue";
</script>

<template>
    <CsaHeader></CsaHeader>
    <slot></slot>
    <CSaFooter></CSaFooter>
</template>

<style scoped>
@import '../style/style.scss';
</style>